import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Input} from '../input'
import {event} from '@cred/shared/ga'
import {emitOnBlur} from '@cred/react-analytics/hoc'
import {InputComponent} from './inputComponent'

const inputComponentWithAnalytics = emitOnBlur(InputComponent)

class AprInput extends Component {
  static propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    small: PropTypes.bool,
    id: PropTypes.string,
    isManualTrade: PropTypes.bool,
    placeholder: PropTypes.string,
    validate: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.arrayOf(PropTypes.func)
    ]),
    className: PropTypes.string,
    forceOpenTooltip: PropTypes.bool,
    type: PropTypes.oneOf(['text', 'tel']),
	  analyticsContexts: PropTypes.array,
  }

  static defaultProps = {
    id: '',
    name: '',
    placeholder: '',
    isManualTrade: false,
    className: '',
    label: '',
    small: false,
    validate: () => {},
    forceOpenTooltip: false,
	  type: 'text',
	  analyticsContexts: [],
  }

  focusHandle = () => {
    const {isManualTrade} = this.props

    event({
      category: 'Refi Prequal Borrower Form',
      action: 'Enter APR',
      label: isManualTrade ? 'Manual Loan' : 'Trade Loan'
    })
  }

  render() {
    const {
      className,
      name,
      label,
      validate,
      placeholder,
      small,
      forceOpenTooltip,
	    type,
      ...props
    } = this.props

    return (
      <div className={className}>
        <Input
          type={type}
          name={`${name}`}
          label={label}
          small={small}
          forceOpenTooltip={forceOpenTooltip}
          component={inputComponentWithAnalytics}
          validate={validate}
          placeholder={placeholder}
          onFocus={this.focusHandle}
          {...props}
        />
      </div>
    )
  }
}

export {AprInput}
